import { Session } from '@/handler/session'
import router from '@/router'

// Esta Ok
const isAutenticado = (to, from, next) => {
  if (Session.getSession()) {
    next()
  } else {
    router.push({ name: 'Init' })
  }
}

// Esta Ok
const isNotAutenticado = (to, from, next) => {
  if (Session.getSession()) {
    router.push({ name: 'Dashboard' })
  } else {
    next()
  }
}

export default {
  IS_AUTENTICADO: isAutenticado, // Esta OK
  IS_NOT_AUTENTICADO: isNotAutenticado, // Esta OK
}
